// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"P6-z","yourQuestionLabel":"Q6-z","notAuthedMessage":"R6-z","form":"S6-z","textarea":"T6-z","error":"U6-z","disabled":"V6-z","edited":"W6-z","submit":"X6-z"};